<script>
export default {
  props: [
    'id',
    'img',
    'imgAlt',
    'url',
    'title',
    'excerpt',
    'date',
    'groups',
    'groupsText',
    'tags',
    'promotestyle',
  ],
  mounted() {},
  data() {
    return {
      tagsFormatted: this.tags ? this.tags.split(',') : [],
      groupsFormatted: this.groups ? this.groups.split(',') : [],
    };
  },
  methods: {
    capitalize(value) {
      if (!value) {
        return '';
      }

      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>

<template>
  <li class="row news-container" :class="promotestyle">
    <article
      :id="this.id"
      class="news-item col-md-10 offset-md-1 col-lg-8 offset-lg-2"
    >
      <div class="row">
        <div class="col-12 col-md-3" v-if="this.img">
          <a :href="this.url" class="d-flex flex-row align-items-start">
            <img
              src="/Static/images/onepixel.png"
              :data-src="this.img"
              class="lazyload"
              :alt="this.imgAlt"
            />
          </a>
        </div>
        <div class="col-12 col-md-9">
          <div class="d-flex flex-column">
            <a :href="this.url" v-if="this.url && this.title">
              <h2 class="heading-level-3">
                {{ this.title }}
              </h2>
            </a>
            <p class="mb-0" v-if="this.excerpt">{{ this.excerpt }}</p>
            <p class="mb-0 mt-2" v-if="this.date">
              {{ capitalize(this.date) }}
            </p>

            <div class="news-tags">
              <span class="mt-3" v-for="tag in tagsFormatted">{{ tag }}</span>
              <span class="mt-3" v-for="group in groupsFormatted">{{
                group
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </article>
  </li>
</template>
